import { render, staticRenderFns } from "./PublishPopoverRow.vue?vue&type=template&id=9868a786&scoped=true&"
import script from "./PublishPopoverRow.vue?vue&type=script&lang=js&"
export * from "./PublishPopoverRow.vue?vue&type=script&lang=js&"
import style0 from "./PublishPopoverRow.vue?vue&type=style&index=0&id=9868a786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9868a786",
  null
  
)

export default component.exports